(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './VisiblePasswordField'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./VisiblePasswordField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.VisiblePasswordField);
    global.index = mod.exports;
  }
})(this, function (exports, _VisiblePasswordField) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, 'VisiblePasswordField', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_VisiblePasswordField).default;
    }
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/form/fields/index.js
// module id = 904
// module chunks = 1